<template>
  <div class="medal-page-wrap" :class="$data.globalData.user.completed_quiz && !$data.globalData.user.medal_subscribed ? 'quiz-completed' : 'height-100'">
    <div class="home-page game-outer" v-if="dataReady">
      <div v-if="showMedal && $data.globalData && $data.globalData.user">
        <div class="medal-details-wrap">
          <div class="medal-details">
            <div class="status-image">
              <img src="/static/images/coin_2023.png" alt="medal">
            </div>
            <h4 class="medal-title">Regluvörður 2023</h4>
            <p class="sub-text">
              Fylltu út formið og fáðu glæsilegan verðlaunapening sendan heim að dyrum.</p>
            <div class="medal-basic-form animate-slidein">
              <div class="medal-block">
                <div class="form-group user">
                  <input  type="name" v-model="medalInfo.name" id="name">
                  <label for="name">Nafn:</label>
                </div>
                <div class="detail-block-outer">
                  <div class="form-group address">
                    <input type="address" id="address" v-model="medalInfo.address">
                    <label for="address">Heimilisfang:</label>
                  </div>
                  <div class="form-group post-num">
                    <input class="integerInputPostNumber" maxlength="3" type="text" id="post-num" v-model="medalInfo.post_number">
                    <label for="post-num">Póstnúmer:</label>
                  </div>
                </div>
              </div>
              <div class="facebook">
                <button class="button medal-send" v-on:click="subscribeMedal()">Senda</button>
                <button type="button" class="button nothanx-btn" v-if="this.$data.globalData.user" v-on:click="final()">
                Nei takk</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex-container">
        <p>Innskráður notandi hefur ekki klárað leikinn. Vinsamlegast skráðu þig inn með netfangi sem hefur klárað leikinn til að fá sendan golfpening</p>
        <div>
          <a class="button btn-svara" href="/spurningar/" >Spila</a>
          <a class="button btn-svara" href="/logout/" >Útskráning</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global gtag */
/* eslint no-undef: "error" */
import { MedalInfo, IcelandicPinCodes } from '@/shared/dataModels'
import API from '@/shared/api'
export default {
  name: 'MedalPage',
  data () {
    return {
      facebook: null,
      medalInfo: new MedalInfo(),
      clubImage: null,
      userTotalPoints: null,
      medalData: {
        'status': false
      },
      shown: false,
      fullName: null,
      dataReady: false,
      userInfo: null,
      mandatoryFields: ['address', 'post_number'],
      missedFields: [],
      icelandicPinCodes: IcelandicPinCodes,
      showMedal: true
    }
  },
  created () {
    if (this.$data.globalData.user && this.$data.globalData.user.user_club) {
      this.clubImage = this.$data.globalData.user.user_club.image_url
      if (this.$data.globalData.user.user_total_points) {
        this.userTotalPoints = this.$data.globalData.user.user_total_points
      }
    }
    if (this.$data.globalData.user) {
      this.userInfo = this.$data.globalData.user
    } else {
      this.showMedal = false
      this.$router.replace({ path: '/innskraning/', query: { next_url: window.location.href } })
    }
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
      if (this.fullName) {
        this.medalInfo.name = this.fullName
      }
    }
    if (this.$route.path.includes('skraning')) {
      this.showMedal = true
    }
    this.dataReady = true
  },
  mounted () {
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/is_IS/sdk.js#xfbml=1&version=v3.0";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  methods: {
    sharePage () {
      const currentPage = encodeURI(window.location.href)
      const sharePage = encodeURI(this.$data.globalData.hosted_domain)
      const href = 'http://www.facebook.com/dialog/send?app_id=' + 
      this.globalData.fb_app_id + '&link=' + sharePage + '&redirect_uri=' + currentPage
      FB.ui({
        method: 'send',
        link: this.$data.globalData.hosted_domain
      })
    },
    subscribeMedal () {
      this.missedFields = this.isValidData()
      if (this.missedFields.length === 0) {
        let verifiedNumber = false
        for (let pencil = 0; pencil < this.icelandicPinCodes.length; pencil++) {
          if (this.icelandicPinCodes[pencil] == this.medalInfo.post_number) {
            verifiedNumber = true
          }
        }
        if(verifiedNumber) {
          API.meInstance.post('/subscribe/medal/', this.medalInfo).then((res) => {
            this.medalData.status = res.data.status
            if (res) {
              if (res.data.status) {
                gtag('config', this.$data.globalData.google_track_id, {
                  'page_title' : 'sendurpeningur',
                  'page_path': '/quiz/?sendurpeningur'
                })
                const h = this.$createElement
                this.$notify({
                  // title: 'Árangur',
                  customClass: 'success-msg',
                  message: h('i', { style: 'color: #6cc65b' }, 'Skráning á heimilisfangi tókst')
                })
                setTimeout(() => {
                  window.location.href = '/fb/share/'
                  this.medalInfo = new MedalInfo()
                }, 2000)
              } else {
                const h = this.$createElement
                this.$notify({
                  // title: 'Villa',
                  customClass: 'error-msg',
                  message: h('i', { style: 'color: #f7653a' }, res.data.error)
                })
              }
            }
          }).catch((error) => {
            const h = this.$createElement
            this.$notify({
              // title: 'Villa',
              customClass: 'error-msg',
              message: h('i', { style: 'color: #f7653a' }, 'Villa, ekki hægt að klára beiðni.')
            })
          })
        } else {
         const h = this.$createElement
          this.$notify({
            // title: 'Villa',
            customClass: 'error-msg',
            message: h('i', { style: 'color: #f7653a' }, 'Ekki var slegið inn gilt póstnúmer')
          })
        }
      } else {
        const h = this.$createElement
        let req = []
        for (let i = 0; i < this.missedFields.length; i++) {
         var key = this.missedFields[i]
          if (!key) return ''
          key = key.toString()
          key = key.split('-').join(' ')
          key = key.split('_').join(' ')
          req.push(' ' + key.charAt(0).toUpperCase() + key.slice(1))
        }
        let filedName = req.join()
        this.$notify({
          // title: 'Villa',
          customClass: 'error-msg',
          message: h('i', { style: 'color: #f7653a' }, 
          'Það verður að fylla út í alla reiti.')
        })
      }
    },
    isValidData () {
      let missedFields = []
      for (let fieldIndex in this.mandatoryFields) {
        if (this.medalInfo && this.medalInfo[this.mandatoryFields[fieldIndex]] && this.medalInfo[this.mandatoryFields[fieldIndex]] !== '') {
          continue
        } else {
          missedFields.push(this.mandatoryFields[fieldIndex])
        }
        
      }
      return missedFields
    },
    final () {
      window.location.href = '/fb/share/?nothanks=true'
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  max-width: 640px;
  margin: 0 auto;
  p {
    text-align: center;
  }
  div {
    text-align: center;
  }
  a {
    padding: 13px 50px;
    text-align: center;
    margin: 5px;
    @media (min-width: 768px) {
      min-width: 200px;
    }
  }
}
.medal-page-wrap {
  // height: calc(100% - 119px);
  height: calc(100% - 66px);
  .game-outer, .game-outer > div {
    height: 100%;
  }
  .medal-details-wrap {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
}
.form-group {
  label {
    text-align: left;
  }
  input {
    padding: 1.3rem;
  }
  &.address {
    width: 75%
  }
  &.post-num {
    width: 25%;
    padding-left: 2rem;
  }
}
.facebook {
  .medal-send {
    margin-right: 2.5rem;
  }
}
.button {
  padding: 1.3rem 11rem;
  border-radius: 10px;
}
.detail-block-outer {
  display: flex;
}
.medal-block {
  display: block;
}
.home-page {
  .medal-details {
    // padding-top: 3rem;
    position: relative;
    max-width: 650px;
    margin: 0 auto;
    text-align: center;
    opacity: 1;
    -webkit-animation-duration: 1.5s;
    animation-duration: 0.8s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: fadingEffect;
    animation-name: fadingEffect;
  }
}
.status-image {
  // svg {
    max-width: 130px;
    margin: 0 auto;
    height: 130px;
  // }
}
.row {
  margin-right: 0;
  margin-left: 0
}
.medal-basic-form {
  padding-top: 25px;
  position: relative;
  opacity: 0;
  animation-duration: 2s;
  animation-fill-mode: both;
  animation-name: medal-form-transition;
  animation-delay: 0s;
}
@keyframes medal-form-transition {
  0% {
      opacity: 0;
      transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@media (max-width: 768px) {
  .form-group {
    &.address {
      width: 70%
    }
    &.post-num {
      width: 30%;
      padding-left: 1.5rem;
    }
  }
  .status-image {
    max-width: 100px;
    height: 96px;
  }
  .status-image, .medal-title, .sub-text {
    animation-duration: 2s;
    animation-fill-mode: both;
    animation-name: medal-form-transition;
    animation-delay: 0s;
  }
  .medal-details-wrap {
    padding-top: 119px;
    .medal-details {
      padding-top: 9rem !important;
    }
    .medal-details .medal-basic-form {
      max-width: 315px;
      margin: 0 auto;
    }
    .facebook .medal-send {
      margin-right: 0;
    }
  }
  .medal-page-wrap {
    &.quiz-completed {
      height: 100%;
    }
    &.height-100 {
      height: 100%;
    }
  }
  .medal-details-wrap {
    padding-top: 0;
    .medal-details .medal-basic-form {
      max-width: 315px;
      margin: 0 auto;
    }
    .facebook .medal-send {
      margin-right: 0;
    }
  }
}
@media (max-width: 480px) {
  .medal-block {
    height: 165px;
  }
}
@media (max-width: 320px) {
  .medal-page-wrap {
    .medal-details-wrap {
      display: block;
    }
  }
  .medal-details-wrap {
    .facebook {
      .medal-send {
        padding: 1.3rem 5.5rem;
      }
    }
  }
}
</style>